module.exports = __webpack_public_path__ + "assets/images/10L-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10L-route-sheet.png
// module id = 1284
// module chunks = 1